import { ReactElement } from 'react'
import { ProjectBackgroundInformation } from 'src/screens/shared/project/details/background-information/ProjectBackgroundInformation'

export const PfPgvBackgroundInformationPage = (): ReactElement => {
  return <ProjectBackgroundInformation baseUrl="/pf-pgv" />
}
